import { Score as ScoreType } from '@/types/summary'
import { Score } from '.'

interface Props {
  score: ScoreType
}
export const Rating: React.FC<Props> = ({ score }) => {
  return (
    <>
      <div className="pt-[5px] pb-[2px] sm:mb-[5px] text-sm">
        <span className="pb-2 border-b-4 border-[#4686ce] border-solid">
          評点
        </span>
      </div>
      <div className="px-[10px] pt-3 pb-[10px] bg-[#f5f5f5]">
        <div className="flex flex-col sm:flex-row w-full">
          <Score text="総合" score={score.total} />
          <Score text="明瞭性" score={score.clarity} />
        </div>
        <div className="flex flex-col sm:flex-row w-full">
          <Score text="革新性" score={score.innovation} />
          <Score text="応用性" score={score.applicability} />
        </div>
      </div>
    </>
  )
}
